// URL-friendly slug from any label ("SMA Kanisius Jakarta" -> "sma-kanisius-jakarta")
export function slugify(text) {
  return (text || "")
    .toString()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80) || "n-a";
}

// Extract the id from a route param that may be a plain id ("sch_abc123") OR
// a slug-prefixed pattern ("sma-kanisius-jakarta-sch_abc123"). Backend ids always
// contain an underscore, so we look for the LAST underscore-prefixed token.
export function extractId(param, prefix) {
  if (!param) return "";
  const p = String(param);
  const marker = `-${prefix}_`;
  const idx = p.lastIndexOf(marker);
  if (idx === -1) return p; // already a bare id (backward compat)
  return p.slice(idx + 1); // returns "prefix_..."
}

// Build a canonical slugged URL segment for a resource (used in <Link to=...>)
export function schoolSlug(s) {
  if (!s) return "";
  const parts = [s.name, s.city].filter(Boolean).join(" ");
  return `${slugify(parts)}-${s.school_id}`;
}

export function threadSlug(t) {
  if (!t) return "";
  return `${slugify(t.title)}-${t.thread_id}`;
}

/**
 * getSchoolUrl(school | {school_id, name, city}) — SINGLE SOURCE OF TRUTH for school URLs.
 *
 * Always use this whenever we render a link/nav to a school so the format stays
 * consistent everywhere (Schools listing, SchoolDetail cross-discovery, Forum, Admin,
 * Home, Profile, MyReviews, BrandDetail, etc.). If the URL scheme ever changes,
 * we edit ONE function and the entire app updates.
 *
 * Falls back gracefully to bare `/schools/{id}` when only the id is known.
 */
export function getSchoolUrl(school, opts = {}) {
  if (!school) return "/sekolah";
  if (typeof school === "string") return `/sekolah/${school}`; // bare id fallback
  const suffix = opts.hash ? `#${opts.hash}` : opts.query ? `?${opts.query}` : "";
  if (!school.name && !school.city) {
    return `/sekolah/${school.school_id || ""}${suffix}`;
  }
  return `/sekolah/${schoolSlug(school)}${suffix}`;
}

/**
 * getThreadUrl(thread) — canonical URL builder for a forum thread. Same rationale
 * as getSchoolUrl: one function, whole-app consistency.
 */
export function getThreadUrl(thread, opts = {}) {
  if (!thread) return "/forum";
  if (typeof thread === "string") return `/forum/${thread}`;
  const suffix = opts.hash ? `#${opts.hash}` : opts.query ? `?${opts.query}` : "";
  if (!thread.title) return `/forum/${thread.thread_id || ""}${suffix}`;
  return `/forum/${threadSlug(thread)}${suffix}`;
}
